export default __webpack_public_path__ + "static/media/Instagram.905f2461.svg";